<form>
  <div mat-dialog-content class="qualificates-theme container-test">
    <div fxFlex fxLayout="column">

      <div fxFlex="100" fxLayout="column">
        <div fxFlex="100" fxLayout="row" class="table-title">
          <div fxFlex="100">
            <div fxFlex="3" style="margin: auto;">
              <span>{{data.data.position}}</span>
            </div>
            <div fxFlex="97" class="title-essay-disabled">
              <mat-form-field class="campoFormulario">
                <input class="input-title-essay" matInput name="title-essay"
                  [ngModel]="dataSource.testDescription" [disabled]="true">
              </mat-form-field>
            </div>
          </div>
        </div>

        <div fxFlex="100">
          <mat-checkbox (change)="setForceAccording($event)" [checked]="dataSource.forceAccording"
            [disabled]="!enableEditEssay()">
            {{ 'executionEdit.dialog.essay.forceAccording' | translate }}
          </mat-checkbox>
        </div>


        <div fxLayout="row" class="table-item title-table-test title-table-withpadding">
          <div fxFlex="100">
            <div fxFlex="100" class="center-text">
              <span> {{ 'protocolEdit.test.dataGeneral.title' | translate }}</span>
            </div>
          </div>
        </div>
        <div fxFlex="100" fxLayout="column" class="container-verification-data">
          <div fxFlex="100" fxLayout="column">
            <div>
              <div fxLayout="column">
                <mat-accordion>
                  <mat-expansion-panel class="overflowX" hideToggle>
                    <mat-expansion-panel-header>
                      <mat-panel-title>
                        <div fxFlex="100" class="table-item title-table-test">
                          <div fxFlex="100">
                            <div fxFlex="95" class="center-text">
                              <span>{{'protocolEdit.test.objetive.title' |
                              translate}}</span>
                            </div>
                          </div>
                        </div>
                      </mat-panel-title>
                    </mat-expansion-panel-header>
                    @for (value of dataSource.executionQTestGeneralData; track value; let indexTest = $index) {
                      <div fxLayout="row"
                        >
                        <div fxFlex="100" fxLayout="column">
                          <div fxFlex="100" class="table-item"
                            style="display: grid; margin-bottom: 50px">
                            <quill-editor #editor class="quill-container" [disabled]="true"
                              [(ngModel)]="value.objective" [name]="'objective' + indexTest"
                              [id]="'objective' + indexTest" [modules]="quillConfig"
                            style="height: auto; font-weight: normal;"></quill-editor>
                          </div>
                        </div>
                      </div>
                    }
                  </mat-expansion-panel>
                </mat-accordion>
              </div>

              <div fxLayout="column">
                <mat-accordion>
                  <mat-expansion-panel class="overflowX" hideToggle>
                    <mat-expansion-panel-header>
                      <mat-panel-title>
                        <div fxFlex="100" class="table-item title-table-test">
                          <div fxFlex="100">
                            <div fxFlex="95" class="center-text">
                              <span>{{'protocolEdit.test.methodology.title' |
                              translate}}</span>
                            </div>
                          </div>
                        </div>
                      </mat-panel-title>
                    </mat-expansion-panel-header>
                    @for (value of dataSource.executionQTestGeneralData; track value; let indexTest = $index) {
                      <div fxLayout="row"
                        >
                        @if (value.methodology) {
                          <div fxFlex="100" fxLayout="column">
                            <div fxLayout="row" fxFlex="100" class="table-item"
                              style="display: grid; margin-bottom: 50px">
                              <quill-editor class="quill-container" [disabled]="true"
                                [(ngModel)]="value.methodology"
                                [name]="'methodology' + indexTest"
                                [id]="'methodology' + indexTest" [modules]="quillConfig"
                              style="height: auto; font-weight: normal;"></quill-editor>
                            </div>
                          </div>
                        }
                      </div>
                    }
                  </mat-expansion-panel>
                </mat-accordion>
              </div>
              <div fxLayout="column">

                @for (value of dataSource.executionQTestGeneralData; track value; let indexTest = $index) {
                  <div fxLayout="row"
                    >
                    <mat-accordion>
                      <mat-expansion-panel class="overflowX" hideToggle>
                        <mat-expansion-panel-header>
                          <mat-panel-title>
                            <div fxFlex="100" class="table-item title-table-test">
                              <div fxFlex="100">
                                <div fxFlex="95" class="center-text">
                                  <span>{{'protocolTest.test.criteria' | translate
                                  }}</span>
                                </div>
                              </div>
                            </div>
                          </mat-panel-title>
                        </mat-expansion-panel-header>
                        @if (value.criteria) {
                          <div fxFlex="100" fxLayout="column">
                            <div fxLayout="row" fxFlex="100" class="table-item"
                              style="display: grid; margin-bottom: 50px">
                              <quill-editor class="quill-container" [(ngModel)]="value.criteria"
                                [name]="'criteria' + indexTest" [id]="'criteria' + indexTest"
                                [modules]="quillConfig" [disabled]="true"
                              style="height: auto; font-weight: normal;"></quill-editor>
                            </div>
                          </div>
                        }
                      </mat-expansion-panel>
                    </mat-accordion>
                  </div>
                }
              </div>
            </div>
          </div>
        </div>

        @if (dataSource.executionQTestEssayGroup != null) {
          <div fxLayout="row"
            class="table-item title-table-test title-table-withpadding">
            <div fxFlex="100">
              <div fxFlex="100" class="center-text">
                <span> {{ 'executionEdit.instrumentationUse.title' | translate }}</span>
              </div>
              <div fxFlex="10" style="text-align: end;" align="end">
                <button mat-raised-button (click)="openCreateDialogInstrumentalUsed()"
                  [disabled]="!showInExecution()" color="accent">
                  <mat-icon>add</mat-icon>
                </button>
              </div>
            </div>
          </div>
        }


        @if (dataSource.executionQTestEssayGroup != null && dataSource.executionQTestEssayGroup?.length > 0) {
          <div
            fxFlex="100" fxLayout="column" class="container-verification-data">
            <div fxFlex="100" fxLayout="column">
              <table #executionQTestInstrumentalUsedTable mat-table
                [dataSource]="dataSource.executionQTestInstrumentalUsed" style="width: 100%;">
                <ng-container matColumnDef="instrumental">
                  <th mat-header-cell *matHeaderCellDef> {{
                    'executionEdit.test.instrumental.cols.instrumental' | translate }}
                  </th>
                  <td mat-cell *matCellDef="let item">{{ item.translation ? ('instrumentation.' +
                  item.translation | translate) : '' }}</td>
                </ng-container>
                <ng-container matColumnDef="edit">
                  <th mat-header-cell *matHeaderCellDef> {{ 'executionEdit.test.observations.cols.edit' |
                    translate }}
                  </th>
                  <td mat-cell *matCellDef="let item; let indexInstrumental = index">
                    <button mat-icon-button
                      (click)="openEditDialogInstrumentalUsed(indexInstrumental, item)"
                      [disabled]="!showInExecution()" matTooltip="{{ 'button.edit' | translate }}">
                      <mat-icon>mode_edit</mat-icon>
                    </button>
                  </td>
                </ng-container>
                <!-- Delete Column -->
                <ng-container matColumnDef="delete">
                  <th mat-header-cell *matHeaderCellDef> {{ 'executionEdit.test.observations.cols.delete'
                    | translate }}
                  </th>
                  <td mat-cell *matCellDef="let item; let indexInstrumental = index">
                    <button mat-icon-button (click)="deleteInstrumentalUsed(indexInstrumental)"
                      [disabled]="!showInExecution()" matTooltip="{{ 'button.delete' | translate }}">
                      <mat-icon>delete</mat-icon>
                    </button>
                  </td>
                </ng-container>
                <tr mat-header-row *matHeaderRowDef="displayedColsInstrumentalUsed"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColsInstrumentalUsed;"></tr>
              </table>
            </div>
          </div>
        }

        @if (dataSource.executionQTestEssayGroup) {
          <div fxFlex="100" fxLayout="column"
            style="margin-bottom: 20px">
            <mat-accordion>
              <mat-expansion-panel class="overflowX" expanded="true">
                <mat-expansion-panel-header>
                  <mat-panel-title>
                    <div fxFlex="100" class="table-item title-table-test">
                      <div fxFlex="100">
                        <div fxFlex="95" class="center-text">
                          <span>{{'protocolEdit.test.dataEssay.title' |
                          translate}}</span>
                        </div>
                      </div>
                    </div>
                  </mat-panel-title>
                </mat-expansion-panel-header>
                <div fxFlex="100" fxLayout="column">
                  <div fxFlex="100">
                    <mat-tab-group style="width: 100%;" [selectedIndex]="_essayIndex"
                      (focusChange)="onEssayTestTabChange($event.index)" dynamicHeight>
                      @for (essay of dataSource.executionQTestEssayGroup; track essay; let indexEssay = $index) {
                        <mat-tab
                          style="min-height: 50vh;">
                          <ng-template mat-tab-label>
                            <span class="tab-text"> {{essay.active ? '' : '🚫'}} {{'essayType.' +
                            essay.translationType | translate}} </span>
                            @if (displayCycle(essay)) {
                              <span class="tab-text"> {{
                                'executionEdit.essays.cicle' | translate }}
                              {{essay.numCycle}} </span>
                            }
                          </ng-template>
                          <div>
                            <mat-checkbox class="example-margin" [id]="'active'+indexEssay"
                              [name]="'active'+indexEssay"
                              (change)="onEssayActiveChange(essay, $event)" [value]="item"
                              [checked]="essay.active">
                              {{'executionEdit.essays.active.title' | translate}}
                            </mat-checkbox>
                            @if (!essay.active) {
                              <p>
                                <mat-label>{{'executionEdit.essays.active.reason' |
                                translate}}</mat-label>
                                <textarea rows="5" matAutosizeMinRows="5" matInput required
                                  [(ngModel)]="essay.reasonActive" [name]="'reason'+indexEssay"
                                  [id]="'reason'+indexEssay" style="resize: none;"
                                (change)="onEssayActiveReasonChange(essay, $event)"></textarea>
                              </p>
                            }
                          </div>
                          <mat-card-content>
                            <mat-toolbar color="secondary">
                              {{ 'executionEdit.essays.additionalInfo' | translate }}
                            </mat-toolbar>
                            <div fxLayout="column">
                              <div fxFlex="100%">
                                <mat-form-field class="campoFormulario" style="width: 100%">
                                  <mat-label>{{ 'executionEdit.essays.title.label' | translate
                                  }}</mat-label>
                                  <input matInput [(ngModel)]="essay.title" [disabled]="true"
                                    [id]="'essayTitle'+indexEssay"
                                    [name]="'essayTitle'+indexEssay">
                                </mat-form-field>
                              </div>
                              <div fxFlex="100%">
                                <mat-form-field class="campoFormulario" style="width: 100%">
                                  <mat-label>{{ 'executionEdit.essays.additionalInfo' |
                                    translate
                                  }}</mat-label>
                                  <textarea rows="5" matAutosizeMinRows="5" matInput
                                    [(ngModel)]="essay.additionalInfo" [disabled]="true"
                                    [id]="'additionalInfo'+indexEssay"
                                    [name]="'additionalInfo'+indexEssay"
                                  style="resize: none;"></textarea>
                                </mat-form-field>
                              </div>
                            </div>
                          </mat-card-content>
                          @if (essay.active) {
                            <mat-tab-group style="width: 100%;" [selectedIndex]="_variableIndex"
                              (focusChange)="onVariableTabChange($event.index)"
                              dynamicHeight>
                              @for (tab of essay.essayValues; track tab; let indexVariable = $index) {
                                <mat-tab
                                  label="{{'variable.' + tab.translationVariable | translate }}"
                                  style="min-height: 50vh;">
                                  @if (tab.fields?.length > 0) {
                                    <mat-toolbar color="secondary">
                                      {{ 'executionEdit.essays.fieldsTitle' | translate }}
                                    </mat-toolbar>
                                  }
                                  <br />
                                  <div fxLayout="row">
                                    <div fxFlex="33" fxFlex.lt-md="100%">
                                      <mat-form-field class="campoFormulario">
                                        <mat-label>{{ 'protocolEdit.dialog.essay.unit.label' |
                                          translate
                                        }}</mat-label>
                                        <mat-select [(ngModel)]="tab.idUnit" required
                                          (selectionChange)="onUnitChange(indexVariable, $event)"
                                          [disabled]="true"
                                          [id]="'unit'+indexEssay+indexVariable"
                                          [name]="'unit'+indexEssay+indexVariable">
                                          @for (item of variableUnits; track item) {
                                            <mat-option
                                              [value]="item.id">
                                              {{item.unit}}
                                            </mat-option>
                                          }
                                        </mat-select>
                                        <mat-error>
                                          {{ 'protocolEdit.dialog.essay.unit.error' |
                                          translate }}
                                        </mat-error>
                                      </mat-form-field>
                                    </div>
                                  </div>
                                  <div fxLayout="row" class="flexwrap">
                                    @for (field of tab.fields; track field; let indexField = $index) {
                                      <div fxFlex="50" fxFlex.lt-md="100%"
                                        >
                                        <!-- STRING -->
                                        @if (field.idTypeField == 1) {
                                          <div>
                                            <mat-form-field class="campoFormulario"
                                              style="width: 90%">
                                              <mat-label>{{ 'protocolEdit.dialog.essay.' +
                                                field.translationField + '.label' | translate
                                              }}</mat-label>
                                              <input matInput disabled="true"
                                                [ngModel]="field.value"
                                                [errorStateMatcher]="matcher"
                                                (ngModelChange)="setValue(tab.idVariable, field, -1, $event)"
                                                [required]="field.required"
                                                [id]="field.translationField+indexEssay+indexVariable+indexField"
                                                [name]="field.translationField+indexEssay+indexVariable+indexField">
                                              <mat-error>
                                                {{ 'protocolEdit.dialog.essay.' +
                                                field.translationField
                                                + '.error' | translate }}
                                              </mat-error>
                                            </mat-form-field>
                                            @if (enableEditField(field)) {
                                              <button mat-icon-button
                                                (click)="openEditField(indexEssay, indexVariable, indexField)">
                                                <mat-icon>edit</mat-icon>
                                              </button>
                                            }
                                          </div>
                                        }
                                        <!-- NUMÉRICO -->
                                        @if (field.idTypeField == 2) {
                                          <div>
                                            <mat-form-field class="campoFormulario"
                                              style="width: 90%">
                                              <mat-label>{{ 'protocolEdit.dialog.essay.' +
                                                field.translationField + '.label' | translate
                                              }}</mat-label>
                                              <input matInput disabled="true"
                                                [ngModel]="field.value"
                                                [errorStateMatcher]="matcher"
                                                (ngModelChange)="setValue(tab.idVariable, field, -1, $event)"
                                                type="number" [required]="field.required"
                                                [id]="field.translationField+indexEssay+indexVariable+indexField"
                                                [name]="field.translationField+indexEssay+indexVariable+indexField">
                                              <mat-error>
                                                {{ 'protocolEdit.dialog.essay.' +
                                                field.translationField
                                                + '.error' | translate }}
                                              </mat-error>
                                            </mat-form-field>
                                            @if (enableEditField(field)) {
                                              <button mat-icon-button
                                                (click)="openEditField(indexEssay, indexVariable, indexField)">
                                                <mat-icon>edit</mat-icon>
                                              </button>
                                            }
                                          </div>
                                        }
                                        <!-- TOLERANCIA -->
                                        @if (field.idTypeField == 3) {
                                          <div>
                                            <div fxFlex="30%" fxFlex.lt-md="100%">
                                              <mat-form-field class="campoFormulario">
                                                <mat-label>{{ 'protocolEdit.dialog.essay.' +
                                                  field.translationField + '.label' |
                                                  translate
                                                }}</mat-label>
                                                <input matInput disabled="true"
                                                  [id]="field.translationField+indexVariable+indexEssay+indexField"
                                                  [name]="field.translationField+indexVariable+indexEssay+indexField"
                                                  [(ngModel)]="field.value[0]"
                                                  (ngModelChange)="setValue(tab.idVariable, field, 0, $event)"
                                                  [errorStateMatcher]="matcher" type="number"
                                                  [required]="field.required">
                                                <mat-error>
                                                  {{ 'protocolEdit.dialog.essay.' +
                                                  field.translationField + '.error' |
                                                  translate }}
                                                </mat-error>
                                              </mat-form-field>
                                            </div>
                                            <div fxFlex="30%" fxFlex.lt-md="100%">
                                              ±
                                              <mat-form-field class="campoFormulario">
                                                <mat-label>{{
                                                  'protocolEdit.dialog.essay.valueTolerance.label'
                                                  |
                                                translate }}</mat-label>
                                                <input matInput disabled="true"
                                                  [id]="field.translationField+'Tolerance'+indexVariable+indexEssay+indexField"
                                                  [name]="field.translationField+'Tolerance'+indexVariable+indexEssay+indexField"
                                                  [(ngModel)]="field.value[1]"
                                                  (ngModelChange)="setValue(tab.idVariable, field, 1, $event)"
                                                  [errorStateMatcher]="matcher" type="number"
                                                  [required]="field.required">
                                                <mat-error>
                                                  {{
                                                  'protocolEdit.dialog.essay.valueTolerance.error'
                                                  | translate }}
                                                </mat-error>
                                              </mat-form-field>
                                            </div>
                                            @if (enableEditField(field)) {
                                              <button mat-icon-button
                                                (click)="openEditField(indexEssay, indexVariable, indexField)">
                                                <mat-icon>edit</mat-icon>
                                              </button>
                                            }
                                          </div>
                                        }
                                        <!-- DIA HORA MIN -->
                                        @if (field.idTypeField == 4) {
                                          <div>
                                            <div fxLayout="row">
                                              <div fxFlex="30%" fxFlex.lt-md="100%">
                                                <mat-form-field class="campoFormulario">
                                                  <mat-label>{{ 'protocolEdit.dialog.essay.' +
                                                    field.translationField + '.label' |
                                                    translate
                                                    }}: {{ 'common.days.label' | translate
                                                  }}</mat-label>
                                                  <input matInput
                                                    [ngModelOptions]="{standalone: true}"
                                                    [id]="field.translationField+'Day'+indexVariable+indexEssay+indexField"
                                                    [name]="field.translationField+'Day'+indexVariable+indexEssay+indexField"
                                                    [(ngModel)]="field.value[0]"
                                                    (ngModelChange)="setValue(tab.idVariable, field, 0, $event)"
                                                    disabled="true"
                                                    [errorStateMatcher]="matcher"
                                                    type="number"
                                                    [required]="field.required" min="0">
                                                </mat-form-field>
                                              </div>
                                              <div fxFlex="30%" fxFlex.lt-md="100%">
                                                <mat-form-field class="campoFormulario">
                                                  <mat-label>{{ 'common.hours.label' |
                                                    translate
                                                  }}</mat-label>
                                                  <input matInput
                                                    [ngModelOptions]="{standalone: true}"
                                                    [id]="field.translationField+'Hour'+indexVariable+indexEssay+indexField"
                                                    [name]="field.translationField+'Hour'+indexVariable+indexEssay+indexField"
                                                    [(ngModel)]="field.value[1]"
                                                    (ngModelChange)="setValue(tab.idVariable, field, 1, $event)"
                                                    [errorStateMatcher]="matcher"
                                                    type="number" disabled="true"
                                                    [required]="field.required" min="0">
                                                </mat-form-field>
                                              </div>
                                              <div fxFlex="30%" fxFlex.lt-md="100%">
                                                <mat-form-field class="campoFormulario">
                                                  <mat-label>{{ 'common.minutes.label' |
                                                    translate
                                                  }}</mat-label>
                                                  <input matInput
                                                    [ngModelOptions]="{standalone: true}"
                                                    [id]="field.translationField+'Minute'+indexVariable+indexEssay+indexField"
                                                    [name]="field.translationField+'Minute'+indexVariable+indexEssay+indexField"
                                                    [(ngModel)]="field.value[2]"
                                                    (ngModelChange)="setValue(tab.idVariable, field, 2, $event)"
                                                    [errorStateMatcher]="matcher"
                                                    type="number" disabled="true"
                                                    [required]="field.required" min="0">
                                                </mat-form-field>
                                              </div>
                                              @if (enableEditField(field)) {
                                                <button mat-icon-button
                                                  (click)="openEditField(indexEssay, indexVariable, indexField)">
                                                  <mat-icon>edit</mat-icon>
                                                </button>
                                              }
                                            </div>
                                          </div>
                                        }
                                        <!-- SELECT_ONE -->
                                        @if (field.idTypeField == 6) {
                                          <div>
                                            <span>
                                              {{ 'protocolEdit.dialog.essay.' +
                                              field.translationField +
                                              '.label' | translate }}
                                            </span>
                                            <br />
                                            <mat-radio-group class="vertical-radio-group"
                                              [id]="'fieldDomain'+indexVariable+indexEssay+indexField"
                                              [name]="'fieldDomain'+indexVariable+indexEssay+indexField"
                                              [required]="fild.required">
                                              @for (doma of field.fieldDomain; track doma) {
                                                <mat-radio-button class="vertical-radio-button"
                                                  [value]="doma.value" disabled="true">
                                                  {{ 'protocolEdit.dialog.essay.' +
                                                  doma.translation +
                                                  '.label' | translate }}
                                                </mat-radio-button>
                                              }
                                            </mat-radio-group>
                                            @if (enableEditField(field)) {
                                              <button mat-icon-button
                                                (click)="openEditField(indexEssay, indexVariable, indexField)">
                                                <mat-icon>edit</mat-icon>
                                              </button>
                                            }
                                          </div>
                                        }
                                        <!-- SELECT_MULTI -->
                                        @if (field.idTypeField == 7) {
                                          <div>
                                            <span>
                                              {{ 'protocolEdit.dialog.essay.' +
                                              field.translationField +
                                              '.label' | translate }}
                                            </span>
                                            @if (enableEditField(field)) {
                                              <button mat-icon-button
                                                (click)="openEditField(indexEssay, indexVariable, indexField)">
                                                <mat-icon>edit</mat-icon>
                                              </button>
                                            }
                                            <mat-selection-list disabled="true"
                                              [id]="field.translationField+'doma'+indexVariable+indexEssay+indexField"
                                              [name]="field.translationField+'doma'+indexVariable+indexEssay+indexField">
                                              @for (doma of field.fieldDomain; track doma) {
                                                <mat-list-option
                                                  checkboxPosition="before" disabled="true"
                                                  [value]="doma.value"
                                                  [selected]="isSelectedMulti(field.value, doma.value)">
                                                  {{ 'protocolEdit.dialog.essay.' +
                                                  doma.translation +
                                                  '.label' | translate }}
                                                </mat-list-option>
                                              }
                                            </mat-selection-list>
                                          </div>
                                        }
                                        <!-- BOOLEAN -->
                                        @if (field.idTypeField == 8) {
                                          <div>
                                            <mat-checkbox [value]="field.value" disabled="true"
                                              [id]="field.translationField+indexVariable+indexEssay+indexField"
                                              [name]="field.translationField+indexVariable+indexEssay+indexField">
                                              {{ 'protocolEdit.dialog.essay.' +
                                              field.translationField +
                                              '.label' | translate }}
                                            </mat-checkbox>
                                            @if (enableEditField(field)) {
                                              <button mat-icon-button
                                                (click)="openEditField(indexEssay, indexVariable, indexField)">
                                                <mat-icon>edit</mat-icon>
                                              </button>
                                            }
                                          </div>
                                        }
                                      </div>
                                    }
                                  </div>
                                  <mat-toolbar color="secondary">
                                    {{ 'executionEdit.essays.criteriaTitle' | translate }}
                                  </mat-toolbar>
                                  <div fxLayout="row" class="flexwrap">
                                    <div fxFlex>
                                      <table mat-table matSort #criteriaTable
                                        [id]="'criterias'+indexVariable+indexEssay+indexField"
                                        [name]="'criterias'+indexVariable+indexEssay+indexField"
                                        [dataSource]="tab.criterias" style="width: 95%;">
                                        <!-- criteria Column -->
                                        <ng-container matColumnDef="criteria">
                                          <th mat-header-cell *matHeaderCellDef
                                            mat-sort-header>
                                            {{
                                            'protocolEdit.dialog.essay.criteria.cols.criteria'
                                            |
                                            translate }}
                                          </th>
                                          <td mat-cell *matCellDef="let item"> {{
                                            showCriteria(item)
                                          }} </td>
                                        </ng-container>
                                        <tr mat-header-row
                                          *matHeaderRowDef="displayedColsCriteria">
                                        </tr>
                                        <tr mat-row
                                          *matRowDef="let row; columns: displayedColsCriteria;">
                                        </tr>
                                      </table>
                                      <br />
                                    </div>
                                  </div>
                                  @if (tab.sensors?.length > 0) {
                                    <mat-toolbar color="secondary">
                                      {{ 'executionEdit.essays.sensorsTitle' | translate }}
                                      @if (enableEditSensor()) {
                                        <button mat-icon-button color="accent" (click)="openNewSensor(indexEssay, indexVariable)"
                                          >
                                          <mat-icon>add</mat-icon>
                                        </button>
                                      }
                                      @if (essay.id != null && enableEditSensor() && essay.idPhoto == null) {
                                        <button mat-icon-button color="primary" (click)="uploadGeneralPhoto.click()"
                                          >
                                          <mat-icon class="mat-icon material-icons opacity50">image</mat-icon>
                                        </button>
                                      }
                                      <input accept="image/*" hidden type="file" (change)="onGeneralPhotoUpload(indexEssay, $event)"
                                        #uploadGeneralPhoto>
                                      @if (essay.id != null && essay.idPhoto != null) {
                                        <button mat-icon-button color="accent" (click)="openDialogGeneralPhoto(indexEssay)"
                                          >
                                          <mat-icon class="mat-icon material-icons">image</mat-icon>
                                        </button>
                                      }
                                      @if (essay.id != null && enableEditSensor()) {
                                        <button mat-icon-button color="accent"
                                          [id]="'sensors'+indexVariable+indexEssay"
                                          [name]="'sensor'+indexVariable+indexVariable+indexEssay"
                                          (click)="openDialogCorrectSensors(indexEssay, indexVariable)"
                                          matTooltip="{{ 'executionEdit.dialog.correctSensor.title' | translate }}">
                                          <mat-icon
                                          class="mat-icon material-icons correctedSensorIcon">done_all</mat-icon>
                                        </button>
                                      }
                                    </mat-toolbar>
                                  }
                                  <div fxLayout="row" class="flexwrap">
                                    <div fxFlex="100%">
                                      @for (sensor of tab.sensors; track sensor; let indexSensor = $index) {
                                        <div fxLayout="row" class="flexwrap"
                                          >
                                          <div fxFlex="15" fxFlex.lt-md="100%">
                                            <mat-form-field class="campoFormulario">
                                              <mat-label>{{
                                                'protocolEdit.dialog.essay.sensors.sensorNum.label'
                                              | translate }}</mat-label>
                                              <input matInput
                                                [name]="'numSensor'+indexEssay+indexVariable+indexSensor+sensor.id"
                                                [id]="'numSensor'+indexEssay+indexVariable+indexSensor+sensor.id"
                                                value="{{ indexSensor + 1 }}" disabled>
                                            </mat-form-field>
                                          </div>
                                          <div fxFlex="30" fxFlex.lt-md="100%">
                                            <mat-form-field class="campoFormulario">
                                              <mat-label>{{
                                                'protocolEdit.dialog.essay.sensors.location.label'
                                                |
                                              translate }}</mat-label>
                                              <input matInput
                                                [name]="'sensorLocation'+indexEssay+indexVariable+indexSensor+sensor.id"
                                                [id]="'sensorLocation'+indexEssay+indexVariable+indexSensor+sensor.id"
                                                [ngModel]="sensor.location" disabled="true">
                                            </mat-form-field>
                                          </div>
                                          <div fxFlex="30" fxFlex.lt-md="100%">
                                            <div fxLayout="row" class="flexwrap">
                                              @if (sensor.corrected) {
                                                <div fxFlex="20px"
                                                  style="margin-top: 1em;margin-right: 1em;">
                                                  <mat-icon class="correctedSensorIcon"
                                                    matTooltip="{{ 'executionEdit.dialog.correctSensor.sensor.tooltip' | translate }}">done_all
                                                  </mat-icon>
                                                </div>
                                              }
                                              @if (!sensor.evaluate) {
                                                <div fxFlex="20px"
                                                  style="margin-top: 1em;">
                                                  <span>❌</span>
                                                </div>
                                              }
                                              @if (sensor.outer) {
                                                <div fxFlex="20px"
                                                  style="margin-top: 1em;">
                                                  <span>️☀️</span>
                                                </div>
                                              }
                                              <div fxFlex>
                                                <mat-form-field class="campoFormulario">
                                                  <mat-label>{{
                                                    'protocolEdit.dialog.essay.sensors.serialNum.label'
                                                  | translate }}</mat-label>
                                                  <input matInput
                                                    [ngModel]="sensor.equipmentName"
                                                    [disabled]="disableSerialNumLabel()"
                                                    #trigger="matAutocompleteTrigger"
                                                    [matAutocomplete]="auto"
                                                    [id]="'inputmatAutocomplete'+indexEssay+indexVariable+indexSensor+sensor.id"
                                                    [name]="'inputmatAutocomplete'+indexEssay+indexVariable+indexSensor+sensor.id"
                                                    (keyup)="lookupEquipment(indexEssay, indexVariable, indexSensor, sensor.id, $event)">
                                                  <mat-autocomplete autoActiveFirstOption
                                                    #auto="matAutocomplete"
                                                    [displayWith]="displayFn"
                                                    [id]="'matAutocomplete'+indexEssay+indexVariable+indexSensor+sensor.id"
                                                    [name]="'matAutocomplete'+indexEssay+indexVariable+indexSensor+sensor.id"
                                                    (optionSelected)='onSensorChange(indexEssay, indexVariable, indexSensor, $event, trigger)'>
                                                    @for (item of getResultsLookup(sensor.id); track item; let index = $index) {
                                                      <mat-option
                                                        [value]="item">
                                                        {{ item.name}}
                                                        ({{item.serialNum}})
                                                      </mat-option>
                                                    }
                                                  </mat-autocomplete>
                                                  <mat-error>
                                                    {{
                                                    'protocolEdit.dialog.essay.sensors.serialNum.error'
                                                    | translate }}
                                                  </mat-error>
                                                </mat-form-field>
                                              </div>
                                              @if (tab.bioindicatorsConfig != null) {
                                                <div fxFlex
                                                  >
                                                  <mat-form-field class="campoFormulario">
                                                    <mat-label>{{
                                                      'protocolEdit.dialog.essay.sensors.bioindicator.label'
                                                    | translate }}</mat-label>
                                                    <input matInput
                                                      [name]="'bioindicatorSerialNumSensor'+indexEssay+indexVariable+indexSensor+sensor.id"
                                                      [id]="'bioindicatorSerialNumSensor'+indexEssay+indexVariable+indexSensor+sensor.id"
                                                      [ngModel]="sensor.bioindicatorSerialNum != null ? sensor.bioindicatorSerialNum : 'N/A'"
                                                      disabled>
                                                  </mat-form-field>
                                                </div>
                                              }
                                              @if (tab.endotoxinsConfig != null) {
                                                <div fxFlex
                                                  >
                                                  <mat-form-field class="campoFormulario">
                                                    <mat-label>{{
                                                      'protocolEdit.dialog.essay.sensors.endotoxin.label'
                                                    | translate }}</mat-label>
                                                    <input matInput
                                                      [name]="'endotoxinSerialNumSensor'+indexEssay+indexVariable+indexSensor+sensor.id"
                                                      [id]="'endotoxinSerialNumSensor'+indexEssay+indexVariable+indexSensor+sensor.id"
                                                      [ngModel]="sensor.endotoxinSerialNum != null ? sensor.endotoxinSerialNum : 'N/A'"
                                                      disabled>
                                                  </mat-form-field>
                                                </div>
                                              }
                                            </div>
                                          </div>
                                          <div fxFlex="25" fxFlex.lt-md="100%">
                                            @if (!photoAlreadyUploaded(indexEssay, indexVariable, indexSensor) && showPhotoButton(indexEssay, indexVariable, indexSensor)) {
                                              <button mat-icon-button
                                                [disabled]="disableUploadPhotoButton()"
                                                (click)="uploadPhoto.click()"
                                                >
                                                <mat-icon
                                                  class="mat-icon material-icons opacity50 {{ styleUploadPhotoButton(indexEssay, indexVariable, indexSensor) }}">
                                                  camera_alt
                                                </mat-icon>
                                              </button>
                                            }
                                            @if (photoAlreadyUploaded(indexEssay, indexVariable, indexSensor) && showPhotoButton(indexEssay, indexVariable, indexSensor)) {
                                              <button mat-icon-button
                                                (click)="openDialogSensorPhoto(indexEssay, indexVariable, indexSensor)"
                                                >
                                                <mat-icon class="mat-icon material-icons">
                                                  camera_alt
                                                </mat-icon>
                                              </button>
                                            }
                                            @if (!excelAlreadyUploaded(indexEssay, indexVariable, indexSensor) && showExcelButton(indexEssay, indexVariable, indexSensor)) {
                                              <button mat-icon-button
                                                [disabled]="disableUploadExcelButton()"
                                                (click)="uploadExcel.click()"
                                                >
                                                <mat-icon
                                                  class="mat-icon material-icons opacity50 {{ styleUploadExcelButton(indexEssay, indexVariable, indexSensor) }}">
                                                  insert_chart
                                                </mat-icon>
                                              </button>
                                            }
                                            @if (excelAlreadyUploaded(indexEssay, indexVariable, indexSensor) && showExcelButton(indexEssay, indexVariable, indexSensor)) {
                                              <button mat-icon-button
                                                (click)="openDialogSensorExcel(indexEssay, indexVariable, indexSensor)"
                                                >
                                                <mat-icon class="mat-icon material-icons">
                                                  insert_chart
                                                </mat-icon>
                                              </button>
                                            }
                                            @if (!primaryAlreadyUploaded(indexEssay, indexVariable, indexSensor) && showPrimaryButton(indexEssay, indexVariable, indexSensor)) {
                                              <button mat-icon-button
                                                [disabled]="disableUploadOriginalButton()"
                                                (click)="uploadPrimaryFile.click()"
                                                >
                                                <mat-icon svgIcon="doc_lock"
                                                  class="mat-icon material-icons opacity50 {{ styleUploadOriginalButton(indexEssay, indexVariable, indexSensor) }}">
                                                </mat-icon>
                                              </button>
                                            }
                                            @if (primaryAlreadyUploaded(indexEssay, indexVariable, indexSensor) && showPrimaryButton(indexEssay, indexVariable, indexSensor)) {
                                              <button mat-icon-button
                                                (click)="openDialogSensorPrimary(indexEssay, indexVariable, indexSensor)"
                                                >
                                                <mat-icon svgIcon="doc_lock"
                                                  class="mat-icon material-icons">
                                                </mat-icon>
                                              </button>
                                            }
                                            <button mat-icon-button
                                              (click)="openEditSensor(indexEssay, indexVariable, indexSensor)">
                                              <mat-icon class="mat-icon material-icons">
                                                build
                                              </mat-icon>
                                            </button>
                                            @if (enableReasonModifyExpositionTime()) {
                                              <button mat-icon-button (click)="openDeleteSensor(indexEssay, indexVariable, indexSensor)"
                                                >
                                                <mat-icon class="mat-icon material-icons">
                                                  delete
                                                </mat-icon>
                                              </button>
                                            }
                                            <input accept="image/*" hidden type="file"
                                              (change)="onPhotoUploadSensor(indexEssay, indexVariable, indexSensor, $event)"
                                              #uploadPhoto>
                                            <input accept=".xlsx, .xls, .csv, .pdf" hidden
                                              type="file"
                                              (change)="onExcelUploadSensor(indexEssay, indexVariable, indexSensor, $event)"
                                              #uploadExcel>
                                            <input accept="*" hidden type="file"
                                              (change)="onPrimaryDataUploadSensor(indexEssay, indexVariable, indexSensor, $event)"
                                              #uploadPrimaryFile>
                                          </div>
                                        </div>
                                      }
                                      <div fxLayout="row" class="flexwrap">
                                        @if (tab.bioindicatorsConfig != null) {
                                          <div fxFlex="20" fxFlex.lt-md="100%"
                                            >
                                            <p> {{ 'executionEdit.bioindicators.valid' |
                                              translate }}
                                            </p>
                                            <mat-radio-group
                                              [(ngModel)]="tab.bioindicatorsConfig.valid"
                                              name="validBioindicators">
                                              <mat-radio-button [value]="true"
                                                [checked]="tab.bioindicatorsConfig.valid === true">
                                                {{'common.yes' | translate}}
                                              </mat-radio-button>
                                              <mat-radio-button [value]="false"
                                                [checked]="tab.bioindicatorsConfig.valid === false">
                                                {{'common.no' | translate}}
                                              </mat-radio-button>
                                              <mat-radio-button [value]="null"
                                                [checked]="tab.bioindicatorsConfig.valid == null">
                                                {{'common.unknown' | translate}}
                                              </mat-radio-button>
                                            </mat-radio-group>
                                          </div>
                                        }
                                        @if (tab.bioindicatorsConfig != null) {
                                          <div fxFlex="33" fxFlex.lt-md="100%"
                                            >
                                            <button mat-raised-button color="accent"
                                              (click)="showDialogConfigBioindicator(indexEssay, indexVariable)">
                                              {{ 'button.configureBioindicators' | translate
                                              }}
                                            </button>
                                          </div>
                                        }
                                        @if (tab.endotoxinsConfig != null) {
                                          <div fxFlex="20" fxFlex.lt-md="100%"
                                            >
                                            <p> {{ 'executionEdit.endotoxins.valid' | translate
                                            }} </p>
                                            <mat-radio-group
                                              [(ngModel)]="tab.endotoxinsConfig.valid"
                                              name="validEndotoxin">
                                              <mat-radio-button [value]="true"
                                                [checked]="tab.endotoxinsConfig.valid === true">
                                                {{'common.yes' | translate}}
                                              </mat-radio-button>
                                              <mat-radio-button [value]="false"
                                                [checked]="tab.endotoxinsConfig.valid === false">
                                                {{'common.no' | translate}}
                                              </mat-radio-button>
                                              <mat-radio-button [value]="null"
                                                [checked]="tab.endotoxinsConfig.valid == null">
                                                {{'common.unknown' | translate}}
                                              </mat-radio-button>
                                            </mat-radio-group>
                                          </div>
                                        }
                                        @if (tab.endotoxinsConfig != null) {
                                          <div fxFlex="33" fxFlex.lt-md="100%"
                                            >
                                            <button mat-raised-button color="accent"
                                              (click)="showDialogConfigEndotoxin(indexEssay, indexVariable)">
                                              {{ 'button.configureEndotoxins' | translate }}
                                            </button>
                                          </div>
                                        }
                                      </div>
                                      <br />
                                      @if (showBowieDick()) {
                                        <div fxLayout="row" class="flexwrap"
                                          >
                                          <div fxFlex="25" fxFlex.lt-md="100%">
                                            <br />
                                            <label
                                              [id]="'labelResultBowie'+indexEssay+indexVariable"
                                              [name]="'labelResultBowie'+indexEssay+indexVariable">
                                              {{'protocolEdit.dialog.essay.criteria.bowieDick.label'
                                              |
                                              translate}}
                                            </label>
                                            <br /> <br />
                                            <mat-radio-group [(ngModel)]="tab.validBowieDick"
                                              [id]="'validBowieDick'+indexEssay+indexVariable"
                                              [name]="'validBowieDick'+indexEssay+indexVariable">
                                              <mat-radio-button
                                                [value]="true">{{'common.correct' |
                                              translate}}</mat-radio-button>
                                              <br />
                                              <mat-radio-button
                                                [value]="false">{{'common.incorrect' |
                                              translate}}</mat-radio-button>
                                            </mat-radio-group>
                                          </div>
                                          <div fxFlex="25" fxFlex.lt-md="100%">
                                            <button mat-raised-button color="accent"
                                              (click)="uploadBowieDickPhoto.click()">
                                              {{ 'button.upload-result' | translate }}
                                            </button>
                                            <input accept="image/*" hidden type="file"
                                              (change)="onPhotoUploadBowieDick($event)"
                                              #uploadBowieDickPhoto>
                                          </div>
                                        </div>
                                      }
                                      @if (tab.showBowieDick === true) {
                                        <br />
                                      }
                                      @if (tab.sensors?.length  > 0) {
                                        <div fxLayout="row" class="flexwrap"
                                          >
                                          <div fxFlex="25" fxFlex.lt-md="100%">
                                            <mat-form-field class="campoFormulario">
                                              <mat-label>{{
                                                'protocolEdit.dialog.essay.criteria.percentSensorsCanFail.label'
                                              | translate }}</mat-label>
                                              <input matInput
                                                [name]="'percentSensorsCanFail'+indexEssay+indexVariable"
                                                [id]="'percentSensorsCanFail'+indexEssay+indexVariable"
                                                [(ngModel)]="tab.percentSensorsCanFail"
                                                required [errorStateMatcher]="matcher"
                                                type="number" disabled
                                                onkeypress="return event.charCode >= 48"
                                                min="0" max="99">
                                              <mat-error>
                                                {{
                                                'protocolEdit.dialog.essay.criteria.percentSensorsCanFail.error'
                                                | translate }}
                                              </mat-error>
                                            </mat-form-field>
                                          </div>
                                          @if (showSetpoint(indexEssay, indexVariable)) {
                                            <div fxFlex="25" fxFlex.lt-md="100%"
                                              >
                                              <mat-form-field class="campoFormulario">
                                                <mat-label>{{
                                                  'protocolEdit.dialog.essay.criteria.setpoint.label'
                                                | translate }}</mat-label>
                                                <input matInput
                                                  [id]="'setpoint'+indexEssay+indexVariable"
                                                  [name]="'setpoint'+indexEssay+indexVariable"
                                                  [(ngModel)]="tab.setpoint"
                                                  [errorStateMatcher]="matcher">
                                              </mat-form-field>
                                            </div>
                                          }
                                          @if (showRealLoad(indexEssay, indexVariable)) {
                                            <div fxFlex="25" fxFlex.lt-md="100%"
                                              >
                                              <mat-form-field class="campoFormulario">
                                                <mat-label>{{
                                                  'protocolEdit.dialog.essay.criteria.dsLoad.label'
                                                  |
                                                translate }}</mat-label>
                                                <input matInput
                                                  [id]="'dsLoad'+indexEssay+indexVariable"
                                                  [name]="'dsLoad'+indexEssay+indexVariable"
                                                  [(ngModel)]="tab.dsLoad"
                                                  [errorStateMatcher]="matcher">
                                              </mat-form-field>
                                            </div>
                                          }
                                          <div fxFlex="25" fxFlex.lt-md="100%">
                                            <mat-checkbox
                                              [id]="'reasonModifyExpositionTime'+indexEssay+indexVariable"
                                              [name]="'reasonModifyExpositionTime'+indexEssay+indexVariable"
                                              [value]="reasonModifyExpositionTime != null"
                                              [checked]="reasonModifyExpositionTime != null"
                                              [disabled]="!enableReasonModifyExpositionTime()"
                                              (change)="openReasonModifyExpositionTime($event)">
                                              {{ 'executionEdit.essays.allowEditGraph' |
                                              translate
                                            }}</mat-checkbox>
                                          </div>
                                        </div>
                                      }
                                      @if (tab.sensors != null && tab.sensors?.length > 0) {
                                        <div fxLayout="row" class="flexwrap"
                                          >
                                          <button mat-raised-button
                                            [disabled]="!showInExecution()"
                                            (click)="openUploadGeneric(indexEssay, indexVariable)"
                                            color="accent">
                                            <mat-icon>backup</mat-icon>
                                            {{ 'button.upload' | translate }}
                                          </button>
                                          <div fxFlex></div>
                                          <div fxFlex="5px"></div>
                                          @if (showCopyToOtherEssay()) {
                                            <button mat-raised-button (click)="copyToEssay()"
                                              color="accent">
                                            {{ 'button.copy-from' | translate }}</button>
                                          }
                                          <div fxFlex="5px"></div>
                                          @if (!disableSerialNumLabel()) {
                                            <button mat-raised-button (click)="copySensorToAll()"
                                              color="accent">
                                            {{ 'button.copy-to-all' | translate }}</button>
                                          }
                                          <div fxFlex="5px"></div>
                                          @if (!disableDefrostsButton()) {
                                            <button mat-raised-button (click)="showDialogDefrost()"
                                              color="accent">
                                            {{ 'button.defrost' | translate }}</button>
                                          }
                                          <div fxFlex="5px"></div>
                                          <button mat-raised-button [hidden]="!showRestartGraph()"
                                            (click)="restartGraph()" color="accent">
                                          {{ 'button.restartGraph' | translate }}</button>
                                        </div>
                                      }
                                    </div>
                                  </div>
                                </mat-tab>
                              }
                            </mat-tab-group>
                          }
                          <div fxFlex="100">
                            @if (displayEssay()) {
                              <app-execution-q-edit-graph #graph
                                (fcStartEssayEmitter)="onFcStartEssayEmit($event)"
                                [idTestType]="getIdTypeEssayCurrent()"
                                (copyDateFirstSensorEmitter)="onCopyTimeGraphChange($event)"
                                (onHotColdSpotEmitter)="onHotColdSpotChange($event)"
                                (onIdPeakEmitter)="onIdPeakChange($event)"
                                (correctlySensorEmitter)="onValidateVerificationEssay($event)">
                              </app-execution-q-edit-graph>
                            }
                          </div>
                          <div mat-dialog-actions class="qualificates-theme">
                            <div fxFlex></div>
                            @if (showInExecution()) {
                              <button mat-raised-button color="primary"
                                (click)="saveEssay(indexEssay)">{{ 'button.save' | translate
                              }}</button>
                            }
                          </div>
                        </mat-tab>
                      }
                    </mat-tab-group>
                  </div>
                </div>
              </mat-expansion-panel></mat-accordion>
            </div>
          }


          @if (data.data.idTestType === 8) {
            <div fxLayout="row"
              class="table-item title-table-test title-table-withpadding">
              <div fxFlex="100">
                <div fxFlex="100" class="center-text">
                  <span> {{ 'executionEdit.criticalInstr.title' | translate }}</span>
                </div>
                <div fxFlex="10" style="text-align: end;" align="end">
                  <button mat-raised-button (click)="openNewCriticalInstrumentation()"
                    [disabled]="!showInExecution()" color="accent">
                    <mat-icon>add</mat-icon>
                  </button>
                </div>
              </div>
            </div>
          }

          @if (data.data.idTestType === 8) {
            <div fxFlex="100" fxLayout="column" class="container-verification-data"
              >
              <section tabindex="0" class="critical-container">
                <table #criticalInstrTable mat-table style="min-width: 90%"
                  [dataSource]="dataSource.executionQTestCriticalInstrumentation">
                  <!-- equipment Column -->
                  <ng-container matColumnDef="equipment">
                    <th mat-header-cell *matHeaderCellDef> {{ 'executionEdit.criticalInstr.equipment.label'
                      | translate }}
                    </th>
                    <td mat-cell *matCellDef="let element">
                      @if (element.idEquipment) {
                        <span> {{element.equipment}}</span>
                      }
                      @if (!element.idEquipment) {
                        <mat-form-field class="campoFormulario"
                          style="width: 95%">
                          <input matInput [(ngModel)]="element.equipment" required
                            [errorStateMatcher]="matcher" [ngModelOptions]="{standalone: true}">
                        </mat-form-field>
                      }
                    </td>
                  </ng-container>
                  <!-- internalId Column -->
                  <ng-container matColumnDef="internalId">
                    <th mat-header-cell *matHeaderCellDef> {{ 'executionEdit.criticalInstr.internalId.label'
                      | translate }}
                    </th>
                    <td mat-cell *matCellDef="let element">
                      @if (element.idEquipment) {
                        <span>{{element.internalId}}</span>
                      }
                      @if (!element.idEquipment) {
                        <mat-form-field class="campoFormulario"
                          style="width: 95%">
                          <input matInput [(ngModel)]="element.internalId" required
                            [errorStateMatcher]="matcher" [ngModelOptions]="{standalone: true}">
                        </mat-form-field>
                      }
                    </td>
                  </ng-container>
                  <!-- maker Column -->
                  <ng-container matColumnDef="maker">
                    <th mat-header-cell *matHeaderCellDef> {{ 'executionEdit.criticalInstr.maker.label' |
                      translate }}
                    </th>
                    <td mat-cell *matCellDef="let element">
                      @if (element.idEquipment) {
                        <span>{{element.maker}}</span>
                      }
                      @if (!element.idEquipment) {
                        <mat-form-field class="campoFormulario"
                          style="width: 95%">
                          <input matInput [(ngModel)]="element.maker" required
                            [errorStateMatcher]="matcher" [ngModelOptions]="{standalone: true}">
                        </mat-form-field>
                      }
                    </td>
                  </ng-container>
                  <!-- model Column -->
                  <ng-container matColumnDef="model">
                    <th mat-header-cell *matHeaderCellDef> {{ 'executionEdit.criticalInstr.model.label' |
                      translate }}
                    </th>
                    <td mat-cell *matCellDef="let element">
                      @if (element.idEquipment) {
                        <span>{{element.model}}</span>
                      }
                      @if (!element.idEquipment) {
                        <mat-form-field class="campoFormulario"
                          style="width: 95%">
                          <input matInput [(ngModel)]="element.model" required
                            [errorStateMatcher]="matcher" [ngModelOptions]="{standalone: true}">
                        </mat-form-field>
                      }
                    </td>
                  </ng-container>
                  <!-- serialNum Column -->
                  <ng-container matColumnDef="serialNum">
                    <th mat-header-cell *matHeaderCellDef> {{ 'executionEdit.criticalInstr.serialNum.label'
                      | translate }}
                    </th>
                    <td mat-cell *matCellDef="let element">
                      @if (element.idEquipment) {
                        <span>{{element.serialNum}}</span>
                      }
                      @if (!element.idEquipment) {
                        <mat-form-field class="campoFormulario"
                          style="width: 95%">
                          <input matInput [(ngModel)]="element.serialNum" required
                            [errorStateMatcher]="matcher" [ngModelOptions]="{standalone: true}">
                        </mat-form-field>
                      }
                    </td>
                  </ng-container>
                  <!-- existsEvidence Column -->
                  <ng-container matColumnDef="existsEvidence">
                    <th mat-header-cell *matHeaderCellDef> {{
                      'executionEdit.criticalInstr.existsEvidence.label' | translate }}
                    </th>
                    <td mat-cell *matCellDef="let element">
                      <mat-form-field class="campoFormulario" style="width: 95%">
                        <input matInput [(ngModel)]="element.existsEvidence" required
                          [errorStateMatcher]="matcher" [ngModelOptions]="{standalone: true}">
                      </mat-form-field>
                    </td>
                  </ng-container>
                  <!-- obs Column -->
                  <ng-container matColumnDef="obs">
                    <th mat-header-cell *matHeaderCellDef>
                      {{ 'executionEdit.criticalInstr.obs.label' | translate }}
                    </th>
                    <td mat-cell *matCellDef="let element">
                      <mat-form-field class="campoFormulario" style="width: 95%">
                        <mat-select multiple [name]="'observations'" [(ngModel)]="element.observations">
                          @for (sel of dataSource.executionQTestDataObservations; track sel) {
                            <mat-option
                              [value]="sel.uuid" matTooltip={{sel.description}}>
                              {{('executionEdit.test.verification.observations.label'| translate) + '
                              ' +sel.position }}
                            </mat-option>
                          }
                        </mat-select>
                      </mat-form-field>
                    </td>
                  </ng-container>
                  <!-- certificateNum Column -->
                  <ng-container matColumnDef="according">
                    <th mat-header-cell *matHeaderCellDef>
                      {{ 'executionEdit.criticalInstr.result.label' | translate }}
                    </th>
                    <td mat-cell *matCellDef="let element; let indexC = index">
                      <mat-form-field class="campoFormulario" style="width: 100%">
                        <mat-select [name]="'resultC'+indexC" [disabled]="!showInExecution()"
                          [(ngModel)]="element.selectedResult"
                          (selectionChange)="onSelectedCriticalResult($event, indexC)">
                          @for (sel of resultCritical; track sel) {
                            <mat-option [value]="sel">
                              {{ 'executionTest.result.' + sel | translate}}
                            </mat-option>
                          }
                        </mat-select>
                      </mat-form-field>
                    </td>
                  </ng-container>
                  <ng-container matColumnDef="deviation" style="width: 60%">
                    <th mat-header-cell *matHeaderCellDef> {{ 'button.deviation' | translate }} </th>
                    <td mat-cell *matCellDef="let element; let deviationIndex = index">
                      <mat-select multiple [name]="'deviationsCritical'+deviationIndex"
                        [disabled]="disabledAccording(element.selectedResult)"
                        [ngModel]="element.uuidDeviation" (selectionChange)="onSelectedDeviationCritical($event, element)">
                        @for (sel of data.deviations; track sel) {
                          <mat-option [value]="sel.uuid">
                            {{ sel.codeDeviation }}
                          </mat-option>
                        }
                      </mat-select>
                    </td>
                  </ng-container>
                  <!-- Button edit Column -->
                  <ng-container matColumnDef="edit">
                    <th mat-header-cell *matHeaderCellDef> {{ 'button.edit' | translate }} </th>
                    <td mat-cell *matCellDef="let element; let equipmentIndex = index">
                      @if (enableEditCriticalInstrumentation()) {
                        <button mat-icon-button
                          (click)="openEditCriticalInstrumentation(equipmentIndex)">
                          <mat-icon>mode_edit</mat-icon>
                        </button>
                      }
                    </td>
                  </ng-container>
                  <!-- uploadCert Column -->
                  <ng-container matColumnDef="uploadCert">
                    <th mat-header-cell *matHeaderCellDef> {{ 'button.upload' | translate }}
                    </th>
                    <td mat-cell *matCellDef="let element">
                      <button mat-icon-button [disabled]="disableUploadCriticalInstrumentationButton()"
                        (click)="uploadCertificateCriticalInstr.click()">
                        <mat-icon style="max-height: 20px; vertical-align: text-bottom;"
                          class="mat-icon material-icons {{ styleUploadCriticalInstrumentationButton(element) }}">
                          cloud_upload
                        </mat-icon>
                      </button>
                      <input accept="application/pdf" hidden type="file"
                        (change)="uploadCertificateCriticalInstrumentation(element, $event)"
                        #uploadCertificateCriticalInstr>
                    </td>
                  </ng-container>
                  <!-- Button delete Column -->
                  <ng-container matColumnDef="delete">
                    <th mat-header-cell *matHeaderCellDef> {{ 'button.delete' | translate }} </th>
                    <td mat-cell *matCellDef="let element; let equipmentIndex = index">
                      <button mat-icon-button (click)="removeCriticalInstrumentation(equipmentIndex)">
                        <mat-icon>delete</mat-icon>
                      </button>
                    </td>
                  </ng-container>
                  <!-- Button delete Column -->
                  <ng-container matColumnDef="save">
                    <th mat-header-cell *matHeaderCellDef> {{ 'button.save' | translate }} </th>
                    <td mat-cell *matCellDef="let element; let criticalIndex = index">
                      <button mat-icon-button [disabled]="!showInExecution()"
                        (click)="updateCritical(criticalIndex, element)">
                        <mat-icon
                        [ngStyle]="{'color': (element?.save ? 'green' : '#8f5da0')}">save</mat-icon>
                      </button>
                    </td>
                  </ng-container>
                  <tr mat-header-row *matHeaderRowDef="criticalInstrCols">
                  </tr>
                  <tr mat-row *matRowDef="let row; columns: criticalInstrCols">
                  </tr>
                </table>
              </section>
            </div>
          }

          @if (dataSource.executionQTestOQVerification && dataSource.executionQTestOQVerification?.length > 0) {
            <div
              >
              <div fxLayout="column">
                <div fxLayout="row" class="table-item title-table-test title-table-withpadding">
                  <span>Verificación de Pruebas</span>
                </div>
                @for (value of dataSource.executionQTestOQVerification; track value; let indexTest = $index) {
                  <div
                    fxLayout="column" fxFlex="100" class="table-item">
                    <div fxLayout="row" fxFlex="100">
                      <div fxFlex="10" class="input-dinamyc-item">
                        <mat-form-field class="campoFormulario">
                          <mat-label>{{ 'Prueba' | translate }}</mat-label>
                          <input matInput [name]="'test' + indexTest" [(ngModel)]="value.test"
                            [disabled]="true">
                        </mat-form-field>
                      </div>
                      <div fxFlex="50" class="table-item">
                        <mat-form-field class="campoFormulario">
                          <mat-label>{{ 'Descripcion' | translate }}</mat-label>
                          <textarea matInput [name]="'descriptionTest' + indexTest"
                            [(ngModel)]="value.descriptionTest" [cdkAutosizeMinRows]="1"
                          cdkTextareaAutosize style="resize: none;" [disabled]="true"></textarea>
                        </mat-form-field>
                      </div>
                      <div fxFlex="20" class="input-dinamyc-item">
                        <mat-form-field class="campoFormulario">
                          <mat-label>{{ 'executionEdit.test.verification.observations.label'| translate
                          }}</mat-label>
                          <mat-select multiple [disabled]="true" [name]="'observations'+indexTest"
                            [(ngModel)]="value.observations">
                            @for (sel of dataSource.executionQTestDataObservations; track sel) {
                              <mat-option
                                [value]="sel.uuid" matTooltip={{sel.description}}>
                                {{ ('executionEdit.test.verification.observations.label'| translate) + '
                                ' +sel.position }}
                              </mat-option>
                            }
                          </mat-select>
                        </mat-form-field>
                      </div>
                      <div fxFlex="20" class="input-dinamyc-item">
                        <mat-form-field class="campoFormulario">
                          <mat-label>{{ 'executionEdit.test.verification.deviation.label'| translate
                          }}</mat-label>
                          <mat-select multiple [disabled]="true"
                            [name]="'deviationsOq'+indexTest"
                            [(ngModel)]="value.uuidDeviation">
                            @for (sel of data.deviations; track sel) {
                              <mat-option [value]="sel.uuid">
                                {{ sel.codeDeviation }}
                              </mat-option>
                            }
                          </mat-select>
                        </mat-form-field>
                      </div>
                      <div fxFlex="20" class="input-dinamyc-item">
                        <mat-form-field class="campoFormulario">
                          <mat-label>{{ 'executionEditQ.test.result' | translate }}</mat-label>
                          <input matInput [name]="'result' + indexTest"
                            [ngModel]="isAccording(value)" [disabled]="true">
                        </mat-form-field>
                      </div>
                    </div>
                  </div>
                }
                <!--<div fxFlex="100" style="text-align: right; margin-bottom: 10px;">
                <button mat-raised-button color="primary" *ngIf="showInExecution()" (click)="saveDataOQ()">{{ 'button.save' | translate }}</button>
              </div>-->
            </div>
          </div>
        }

        @if (dataSource.executionQTestItemGroup && dataSource.executionQTestItemGroup?.length > 0) {
          <div fxFlex="100" fxLayout="column"
            >
            <div fxLayout="row" class="table-item title-table-test title-table-withpadding">
              <div fxFlex="100">
                <div fxFlex="100" class="center-text">
                  <span>{{'protocolTest.test.verification.title' | translate }}</span>
                </div>
              </div>
            </div>
            <mat-tab-group [selectedIndex]="_groupItem" (focusChange)="onEssayTabChange($event.index)">
              @for (group of dataSource.executionQTestItemGroup; track group; let indexGroup = $index) {
                <mat-tab
                  style="min-height: 50vh;">
                  <ng-template mat-tab-label>
                    <span class="tab-text"> {{ group.translationType ? ('essayType.' +
                    group.translationType | translate) + ' ' : ''}} </span>
                    @if (group.title) {
                      <span class="tab-text" style="margin-left: 5px">{{ ' ('+
                      group.title +') '}}</span>
                    }
                    @if (displayCycle(group)) {
                      <span class="tab-text" style="margin-left: 5px"> {{
                      'testQualification.cicle' | translate }} {{group.numCycle}} </span>
                    }
                  </ng-template>
                  @if (group?.executionQTestItems?.length > 0) {
                    <div>
                      <div fxLayout="column">
                        <div fxFlex="100" fxLayout="column" class="container-verification-data">
                          @for (item of group?.executionQTestItems; track item; let indexItem = $index) {
                            <div fxFlex="100"
                              fxLayout="column">
                              <div fxFlex="100" fxLayout="row" class="table-item">
                                <div fxFlex="50">
                                  <mat-form-field class="campoFormulario">
                                    <mat-label>{{ 'Item' | translate }}</mat-label>
                                    <input matInput [name]="'item'+indexItem"
                                      [(ngModel)]="item.description" [disabled]="true">
                                  </mat-form-field>
                                </div>
                              </div>
                              @for (valueItemV of item.executionQTestItemVerification; track valueItemV; let indexItemV = $index) {
                                <div
                                  class="container-verification">
                                  <div fxFlex="100" fxLayout="column" class="table-item">
                                    <div fxFlex="100" fxLayout="row">
                                      <div [fxFlex]="valueItemV.byteImage ? 80 : 100">
                                        <div fxFlex="100">
                                          <mat-form-field class="campoFormulario">
                                            <mat-label>{{ 'Verificación' | translate
                                            }}</mat-label>
                                            <textarea matInput
                                              [name]="'verificationTypeDesc'+indexGroup+indexItem+indexItemV"
                                              [(ngModel)]="valueItemV.verification" rows="1"
                                            [disabled]="true"></textarea>
                                          </mat-form-field>
                                        </div>
                                      </div>
                                      @if (valueItemV.byteImage) {
                                        <div fxFlex="20">
                                          <img [name]="'verificationTypeDescImg'+indexGroup+indexItem+indexItemV" [src]="'data:image/png;'+valueItemV.byteImage" />
                                        </div>
                                      }
                                    </div>
                                    @for (value of valueItemV.executionQTestDataMultiple; track value; let indexValue = $index) {
                                      <div
                                        fxLayout="column">
                                        <div fxFlex="100" [fxLayout]="value.onlyLine ? 'row' : 'column'"
                                          class="table-item">
                                          <div [fxFlex]="value.onlyLine ? 50 : 100">
                                            <div [fxFlex]="value.byteImage ? 90 : 100">
                                              <mat-form-field class="campoFormulario">
                                                @if (!value.expectedResultRhDesc) {
                                                  <mat-label>{{
                                                  'Resultado esperado' | translate }}</mat-label>
                                                }
                                                @if (value.expectedResultRhDesc) {
                                                  <mat-label>{{
                                                  value.expectedResultRhDes }}</mat-label>
                                                }
                                                <textarea matInput
                                                  [name]="'expectedResultDesc'+indexGroup+indexItem+indexItemV+indexValue"
                                                  [(ngModel)]="value.expectedResultDesc"
                                                  [disabled]="!value.onlyLine"
                                                  #autosizeVerification="cdkTextareaAutosize"
                                                  cdkTextareaAutosize
                                                [cdkAutosizeMinRows]="1"></textarea>
                                              </mat-form-field>
                                            </div>
                                            @if (value.byteImage) {
                                              <div fxFlex="10" class="container-img-verification">
                                                <img style="height: 100%;" [name]="'expectedResultDescImg'+indexGroup+indexItem+indexItemV+indexValue" [src]="'data:image/png;'+value.byteImage" alt="Imagen desde backend" />
                                              </div>
                                            }
                                          </div>
                                          <div fxFlex="100" fxLayout="row" fxLayoutAlign="start start"
                                            fxLayoutGap="gappx">
                                            @if (!value.onlyLine) {
                                              <div fxFlex="50" fxLayout="column" class="table-item"
                                                >
                                                <div fxFlex="100" fxLayout="row">
                                                  <div fxFlex="100">
                                                    <mat-form-field class="campoFormulario">
                                                      <mat-label>{{ 'Resultado Obtenido' |
                                                      translate }}</mat-label>
                                                      <textarea matInput
                                                        [name]="'obtainedResult'+indexGroup+indexItem+indexItemV+indexValue"
                                                        [ngStyle]="{'background': !value.obtainedResult ? '#d5d5d5a3': 'transparent'}"
                                                        [(ngModel)]="value.obtainedResult"
                                                        (input)="onBlurObtainedResult($event, indexGroup, indexItem, indexItemV, indexValue)"
                                                        [cdkAutosizeMinRows]="1"
                                                        cdkTextareaAutosize
                                                      style="resize: none;"></textarea>
                                                    </mat-form-field>
                                                  </div>
                                                </div>
                                              </div>
                                            }
                                            <div [fxFlex]="value.onlyLine ? 30 : 15"
                                              fxLayout="column"
                                              class="table-item input-dinamyc-item">
                                              <div fxFlex="100" fxLayout="row">
                                                <div fxFlex="100">
                                                  <mat-form-field class="campoFormulario">
                                                    <mat-label>{{
                                                      'executionEdit.test.verification.observations.label'
                                                    | translate }}</mat-label>
                                                    <mat-select multiple
                                                      [name]="'observations'+indexGroup+indexItem+indexItemV+indexValue"
                                                      [(ngModel)]="value.observations">
                                                      @for (sel of dataSource.executionQTestDataObservations; track sel) {
                                                        <mat-option
                                                          [value]="sel.uuid"
                                                          matTooltip={{sel.description}}>
                                                          {{
                                                          ('executionEdit.test.verification.observations.label'|
                                                          translate) + ' ' +sel.position
                                                          }}
                                                        </mat-option>
                                                      }
                                                    </mat-select>
                                                  </mat-form-field>
                                                </div>
                                              </div>
                                            </div>
                                            <div [fxFlex]="value.onlyLine ? 40 : 20"
                                              class="input-dinamyc-item">
                                              <mat-form-field class="campoFormulario">
                                                <mat-label>{{ 'Resultado' | translate
                                                }}</mat-label>
                                                <mat-select [disabled]="!showInExecution()"
                                                  [name]="'sResultDesc'+indexGroup+indexItem+indexItemV+indexValue"
                                                  [(ngModel)]="value.selectedResult"
                                                  (selectionChange)="onSelectedVerificationResult($event, indexGroup, indexItem, indexItemV, indexValue)">
                                                  @for (sel of value.resultDesc; track sel) {
                                                    <mat-option
                                                      [value]="sel">
                                                      {{ 'executionTest.result.' + sel |
                                                      translate
                                                      }}
                                                    </mat-option>
                                                  }
                                                </mat-select>
                                              </mat-form-field>
                                            </div>
                                            <div [fxFlex]="35" fxLayout="column"
                                              class="table-item input-dinamyc-item">
                                              <div fxFlex="100" fxLayout="row">
                                                <div fxFlex="100">
                                                  <mat-form-field class="campoFormulario">
                                                    <mat-label>{{
                                                      'executionEdit.test.verification.deviation.label'
                                                    | translate }}</mat-label>
                                                    <mat-select multiple
                                                      [disabled]="disabledAccording(value.selectedResult)"
                                                      [name]="'deviations'+indexGroup+indexItem+indexItemV+indexValue"
                                                      [ngModel]="value.uuidDeviation"
                                                      (selectionChange)="onSelectedDeviation($event, value)">
                                                      @for (sel of data.deviations; track sel) {
                                                        <mat-option
                                                          [value]="sel.uuid">
                                                          {{ sel.codeDeviation }}
                                                        </mat-option>
                                                      }
                                                    </mat-select>
                                                  </mat-form-field>
                                                </div>
                                              </div>
                                            </div>
                                            <!--<div [fxFlex]="value.onlyLine ? 10 : 5" class="input-dinamyc-item">
                                            <button mat-icon-button color="accent"
                                              *ngIf="value?.uuidDeviation != null && value.uuidDeviation.length > 0"
                                              (click)="showDeviationSelected(indexGroup, indexItem, indexItemV, indexValue)">
                                              <mat-icon
                                              [ngStyle]="{'color': (devIsClose(indexGroup, indexItem, indexItemV, indexValue) ? 'green' : 'red')}">note_add</mat-icon>
                                            </button>
                                          </div>-->
                                          <div fxFlex="5" class="input-dinamyc-item">
                                            <button mat-icon-button color="accent"
                                              (click)="updateDataMultiple(indexGroup, indexItem, indexItemV, indexValue, value)"
                                              [disabled]="!showInExecution()">
                                              <mat-icon
                                              [ngStyle]="{'color': (value?.save ? 'green' : '#8f5da0')}">save</mat-icon>
                                            </button>
                                          </div>
                                        </div>
                                      </div>
                                      @if (value.regUser) {
                                        <div fxFlex="100">
                                          <div fxFlex="50">
                                            <mat-form-field class="campoFormulario">
                                              <mat-label>{{
                                                'executionEdit.form.test.verification.username.label'
                                              | translate }}</mat-label>
                                              <input matInput
                                                [name]="'usernameDataMultiple'+indexGroup+indexItem+indexItemV+indexValue"
                                                [ngModel]="value.regUser" [disabled]="true">
                                            </mat-form-field>
                                          </div>
                                          <div fxFlex="50">
                                            <mat-form-field class="campoFormulario">
                                              <mat-label>{{
                                                'executionEdit.form.test.verification.date.label'
                                              | translate }}</mat-label>
                                              <input matInput
                                                [name]="'dateDataMultiple'+indexGroup+indexItem+indexItemV+indexValue"
                                                [ngModel]="value.regDate | fixDateTime"
                                                [disabled]="true">
                                            </mat-form-field>
                                          </div>
                                        </div>
                                      }
                                      @if (value.modUser) {
                                        <div fxFlex="100">
                                          <div fxFlex="50">
                                            <mat-form-field class="campoFormulario">
                                              <mat-label>{{
                                                'executionEdit.form.test.verification.username.mod.label'
                                              | translate }}</mat-label>
                                              <input matInput
                                                [name]="'usernameMofDataMultiple'+indexGroup+indexItem+indexItemV+indexValue"
                                                [ngModel]="value.modUser" [disabled]="true">
                                            </mat-form-field>
                                          </div>
                                          <div fxFlex="50">
                                            <mat-form-field class="campoFormulario">
                                              <mat-label>{{
                                                'executionEdit.form.test.verification.date.mod.label'
                                              | translate }}</mat-label>
                                              <input matInput
                                                [name]="'dateMofDataMultiple'+indexGroup+indexItem+indexItemV+indexValue"
                                                [ngModel]="value.modDate | fixDateTime"
                                                [disabled]="true">
                                            </mat-form-field>
                                          </div>
                                        </div>
                                      }
                                    </div>
                                  }
                                </div>
                              </div>
                            }
                          </div>
                        }
                      </div>
                    </div>
                  </div>
                }
              </mat-tab>
            }
          </mat-tab-group>
          <div fxFlex="100" fxLayout="column">
            <div fxLayout="row" class="table-item title-table-test title-table-withpadding">
              <div fxFlex="100">
                <div fxFlex="100" class="center-text">
                  <span>{{'executionEdit.test.deviation.title' | translate }}</span>
                </div>
                <!--div fxFlex="20" style="text-align: end;">
                <button mat-raised-button (click)="openCreateDialogDeviation()"
                  [disabled]="!showInExecution()" color="accent">
                  <mat-icon>add</mat-icon>
                </button>
              </div>-->
            </div>
          </div>
          <table #devTable mat-table [dataSource]="data.deviations" style="width: 100%;">
            <ng-container matColumnDef="code">
              <th mat-header-cell *matHeaderCellDef> {{
                'executionEdit.test.deviation.cols.code' | translate }}
              </th>
              <td mat-cell *matCellDef="let item"> {{item.codeDeviation}} </td>
            </ng-container>
            <ng-container matColumnDef="valuation">
              <th mat-header-cell *matHeaderCellDef> {{
                'executionEdit.test.deviation.cols.valuation' | translate }}
              </th>
              <td mat-cell *matCellDef="let item"> {{ getValuationDeviation(item) }} </td>
            </ng-container>
            <ng-container matColumnDef="resolved">
              <th mat-header-cell *matHeaderCellDef> {{
                'executionEdit.test.deviation.cols.resolved' | translate }}
              </th>
              <td mat-cell *matCellDef="let item"> {{ getResolvedDeviation(item) }} </td>
            </ng-container>
            <ng-container matColumnDef="modDate">
              <th mat-header-cell *matHeaderCellDef> {{
                'executionEdit.test.deviation.cols.modDate' | translate }}
              </th>
              <td mat-cell *matCellDef="let item"> {{ item.modDate | fixDateTime }} </td>
            </ng-container>
            <ng-container matColumnDef="modUser">
              <th mat-header-cell *matHeaderCellDef> {{
                'executionEdit.test.deviation.cols.modUser' | translate }}
              </th>
              <td mat-cell *matCellDef="let item"> {{ item.modUser }} </td>
            </ng-container>
            <ng-container matColumnDef="edit">
              <th mat-header-cell *matHeaderCellDef> {{ 'executionEdit.test.deviation.cols.edit' |
                translate }}
              </th>
              <td mat-cell *matCellDef="let item">
                <button mat-icon-button (click)="showDeviationSelectedIndividual(item.uuid)"
                  [disabled]="!showInExecution()" matTooltip="{{ 'button.edit' | translate }}">
                  <mat-icon>mode_edit</mat-icon>
                </button>
              </td>
            </ng-container>
            <tr mat-header-row *matHeaderRowDef="displayedColsDeviations"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColsDeviations;"></tr>
          </table>
        </div>
        <div fxFlex="100" fxLayout="column">
          <div fxLayout="row" class="table-item title-table-test title-table-withpadding">
            <div fxFlex="100">
              <div fxFlex="80" class="center-text">
                <span>{{'executionEdit.test.observation.title' | translate }}</span>
              </div>
              <div fxFlex="20" style="text-align: end;">
                <button mat-raised-button (click)="openCreateDialogTestObservations()"
                  [disabled]="!showInExecution()" color="accent">
                  <mat-icon>add</mat-icon>
                </button>
              </div>
            </div>
          </div>
          <table #obsTestTable mat-table [dataSource]="dataSource.executionQTestDataObservations"
            style="width: 100%;">
            <ng-container matColumnDef="position">
              <th mat-header-cell *matHeaderCellDef> {{
                'executionEdit.test.observations.cols.position' | translate }}
              </th>
              <td mat-cell *matCellDef="let item"> {{item.position}} </td>
            </ng-container>
            <ng-container matColumnDef="description">
              <th mat-header-cell *matHeaderCellDef> {{
                'executionEdit.test.observations.cols.description' | translate }}
              </th>
              <td mat-cell *matCellDef="let item"> {{ item.description }} </td>
            </ng-container>
            <ng-container matColumnDef="edit">
              <th mat-header-cell *matHeaderCellDef> {{ 'executionEdit.test.observations.cols.edit' |
                translate }}
              </th>
              <td mat-cell *matCellDef="let item">
                <button mat-icon-button (click)="openEditDialogTestObservations(item)"
                  [disabled]="!showInExecution()" matTooltip="{{ 'button.edit' | translate }}">
                  <mat-icon>mode_edit</mat-icon>
                </button>
              </td>
            </ng-container>
            <!-- Delete Column -->
            <ng-container matColumnDef="delete">
              <th mat-header-cell *matHeaderCellDef> {{ 'executionEdit.test.observations.cols.delete'
                | translate }}
              </th>
              <td mat-cell *matCellDef="let item">
                <button mat-icon-button (click)="deleteTestObservations(item)"
                  [disabled]="!showInExecution()" matTooltip="{{ 'button.delete' | translate }}">
                  <mat-icon>delete</mat-icon>
                </button>
              </td>
            </ng-container>
            <tr mat-header-row *matHeaderRowDef="displayedColsObservations"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColsObservations;"></tr>
          </table>
        </div>
      </div>
    }

  </div>

  @if (data?.data?.id) {
    <app-execution-q-edit-test-attachments #attachmentsTestComponent [idExecution]="data.data.idExecution"
      [idTest]="data.data.id" [idStatus]="data.idStatus">
    </app-execution-q-edit-test-attachments>
  }
</div>
</div>
<div mat-dialog-actions class="qualificates-theme">
  <div fxFlex="20" fxLayout="column">
    {{dataSource.according != null ? ('executionEditQ.test.result' | translate) + " " + ('resultTypeSelected.'+
    dataSource.according | translate) :""}}
  </div>
  @if (dataSource.validatedUser) {
    <div fxFlex="10">
      {{dataSource.validatedUser ? ('executionEdit.test.validate.user.label' | translate) + " " +
      dataSource.validatedUser: ""}}
    </div>
  }
  @if (dataSource.validatedDate) {
    <div fxFlex="10">
      {{dataSource.validatedDate ? ('executionEdit.test.validate.date.label' | translate) + " " +
      (dataSource.validatedDate | fixDateTime) : ""}}
    </div>
  }
  <div fxFlex></div>
  @if (showValidate()) {
    <button mat-raised-button color="primary" (click)="validateTest()">{{
    'button.test.validate' | translate }}</button>
  }
  @if (showInExecution()) {
    <button mat-raised-button color="primary" (click)="onOkClick()">{{ 'button.accept' |
    translate }}</button>
  }
  <button mat-raised-button color="secondary" (click)="onNoClick()">{{ 'button.cancel' | translate }}</button>
</div>
</form>